import { formatName, getDay, perc2color } from "../functions"

function formatAgendaHeatMap(heatMap) {
  const result = {}
  const blocks = heatMap.blocks.reduce((acc, block) => {
    const background = block.blocked ? '#adadad' : perc2color({ center: 60, percent: block.free, direction: 1 })

    acc[block.hour] = {
      ...block,
      background
    }
    return acc
  }, {})


  result[heatMap.date] = {
    blocks,
    hours: Object.keys(blocks),
    date: getDay(heatMap.date).format('YYYY-MM-DD'),
    weekDay: formatName(getDay(heatMap.date).format('ddd DD/MM')),
    loading: false
  }
  return result
}


export const formatResponses = {
  heatMap: (heatMap) => formatAgendaHeatMap(heatMap),
};
